__webpack_require__.p = "https://dashboard-dev.adlerlocal.com/";